import React from "react";
import javascript from "../assets/javascript.png";
import reactImage from "../assets/react.png";
import pandas from "../assets/pandas.png";
import ethereum from "../assets/ethereum.png";
import gpt from "../assets/gpt.png";
import mistral from "../assets/mistral.png";
import matplotlib from "../assets/matplotlib.png";
import seaborn from "../assets/seaborn.png";
import rag from "../assets/rag.png";
import tensorflow from "../assets/tensorflow.png";
import crewai from "../assets/crewai.png";
import langchain from "../assets/langchain.png";

const Tech = () => {
  const techs = [
    {
      id: 1,
      src: pandas,
      title: "Pandas",
      style: "shadow-green-500",
    },
    {
      id: 2,
      src: crewai,
      title: "CrewAI",
      style: "shadow-pink-500",
    },
    {
      id: 3,
      src: rag,
      title: "RAG",
      style: "shadow-blue-500",
    },
    {
      id: 4,
      src: tensorflow,
      title: "TensorFlow",
      style: "shadow-orange-500",
    },
    {
      id: 5,
      src: seaborn,
      title: "Seaborn",
      style: "shadow-blue-500",
    },
    {
      id: 6,
      src: matplotlib,
      title: "Matplotlib",
      style: "shadow-white",
    },
    {
      id: 7,
      src: langchain,
      title: "Langchain",
      style: "shadow-white",
    },
    {
      id: 8,
      src: mistral,
      title: "Mistral",
      style: "shadow-orange-500",
    },
    {
      id: 9,
      src: gpt,
      title: "GPT",
      style: "shadow-white",
    },
    {
      id: 10,
      src: ethereum,
      title: "Ethereum",
      style: "shadow-purple-500",
    },
    {
      id: 11,
      src: javascript,
      title: "JavaScript",
      style: "shadow-yellow-600",
    },
    {
      id: 12,
      src: reactImage,
      title: "React",
      style: "shadow-blue-500",
    },
  ];

  return (
    <div
      name="tech"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-auto"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-auto text-white">
        <div className="mt-32">
          <p
            style={{ fontFamily: "'Orbitron', sans-serif" }}
            className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline"
          >
            Tech Stack
          </p>

        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt={title} className="w-20 mx-auto" />
              <p
                style={{ fontFamily: "sans-serif" }}
                className="mt-4"
              >
                {title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tech;


